/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * VisitLatLngDtoBase
 * auto generated base class for the model VisitLatLngDtoModel.
 */
export const VisitLatLngDtoModelBase = ModelBase
  .named('VisitLatLngDto')
  .props({
    __typename: types.optional(types.literal("VisitLatLngDto"), "VisitLatLngDto"),
    visitId: types.union(types.undefined, types.string),
    locationId: types.union(types.undefined, types.string),
    locationStatusId: types.union(types.undefined, types.integer),
    latitude: types.union(types.undefined, types.null, types.number),
    longitude: types.union(types.undefined, types.null, types.number),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class VisitLatLngDtoModelSelector extends QueryBuilder {
  get visitId() { return this.__attr(`visitId`) }
  get locationId() { return this.__attr(`locationId`) }
  get locationStatusId() { return this.__attr(`locationStatusId`) }
  get latitude() { return this.__attr(`latitude`) }
  get longitude() { return this.__attr(`longitude`) }
}
export function selectFromVisitLatLngDto() {
  return new VisitLatLngDtoModelSelector()
}

export const visitLatLngDtoModelPrimitives = selectFromVisitLatLngDto().visitId.locationId.locationStatusId.latitude.longitude
